import React, { useEffect, useState } from "react";

import { ReactComponent as MenuIcon } from "../../assets/icons/menu.svg";
import {
  FaDollarSign,
  FaCalendarAlt,
  FaChartLine,
  FaCalculator,
} from "react-icons/fa";
import { FaAngleDown } from "react-icons/fa6";

import { ReactComponent as Close } from "../../assets/icons/close.svg";
import { AnimatePresence, motion } from "framer-motion";
import { Link, NavLink, useLocation } from "react-router-dom";

import "./Navigation.scss";
import Loogo from "../../assets/images/logo.png";

const Navigation: React.FC = () => {
  const [openClose, setOpenClose] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dropdownOpens, setDropdownOpens] = useState(false);
  const [showDropdown1, setShowDropdown1] = useState(false);
  const [showDropdown2, setShowDropdown2] = useState(false);

  const activeSections = "plans"; // Replace this with actual state management if needed.

  const [activeLink, setActiveLink] = useState("");

  useEffect(() => {
    const currentUrlPathname = window.location.pathname;

    // Set the active link based on the current URL pathname
    setActiveLink(currentUrlPathname);
  }, []);

  useEffect(() => {
    if (openClose) {
      document.body.style.overflowY = "hidden";
      document.body.style.height = "100vh";
    } else {
      document.body.style.overflowY = "initial";
      document.body.style.height = "initial";
    }
  }, [openClose]);

  const [activeSection, setActiveSection] = useState("home");

  useEffect(() => {
    const sections = [
      "about",
      "tokenomics",
      "work",
      "roadmap",
      "team",
      "partners",
    ]; // Add more section IDs if needed
    const observer = new IntersectionObserver(
      (entries) => {
        let foundActive = false;

        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id);
            foundActive = true;
          }
        });

        // Default to "home" only if no other section is active
        if (!foundActive) {
          setActiveSection("home");
        }
      },
      {
        root: null, // Viewport as the container
        rootMargin: "0px", // No margin
        threshold: 0.5, // Adjust as needed
      }
    );

    sections.forEach((id) => {
      const target = document.getElementById(id);
      if (target) observer.observe(target);
    });

    return () => {
      sections.forEach((id) => {
        const target = document.getElementById(id);
        if (target) observer.unobserve(target);
      });
    };
  }, []);

  return (
    <div className="navigation-wrapper">
      <div className="mx">
        <div className="desktophead">
          <div>
            {" "}
            <a href="https://godriveauto.ca/">
            <img src={Loogo} className="logoo" /></a>
          </div>
          <div className="site-nav">
            {" "}
            <nav className="site-navigation">
              <ul className="nav">
              <li>
                  <a
                    href="https://godriveauto.ca"
                    className={`navlink ${
                      activeSection === "home" ? "active" : ""
                    }`}
                  >
                    Home
                  </a>
                </li>
                <li>
                  <Link
                    to="/pre-approval"
                    className={`navlink ${
                      activeSection === "home" ? "active" : ""
                    }`}
                  >
                    Get Pre-Approved
                  </Link>
                </li>
                <li>
                  <Link
                    to="./sell-your-car"
                    className={`navlink ${
                      activeSection === "about" ? "active" : ""
                    }`}
                    onClick={() => {
                      const section = document.querySelector("about");
                      section?.scrollIntoView({ behavior: "smooth" });
                    }}
                  >
                    Sell My Car
                  </Link>
                </li>

                <li>
                  <Link
                    to="./"
                    className={`navlink ${
                      activeSection === "why" ? "active" : ""
                    }`}
                    onClick={() => {
                      const section = document.querySelector("#why");
                      section?.scrollIntoView({ behavior: "smooth" });
                    }}
                  >
                    Inventory
                  </Link>
                </li>

                <li>
                  <a
                    href="https://godriveauto.ca/testimonials"
                    className={`navlink ${
                      activeSection === "why" ? "active" : ""
                    }`}
                  >
                    Customer Reviews
                  </a>
                </li>

                <li
                  className="relative group"
                  onMouseEnter={() => setDropdownOpen(true)}
                  onMouseLeave={() => setDropdownOpen(false)}
                >
                  {/* Main Nav Link */}
                  <Link to="#" className="navlink flex items-center">
                    Resources{" "}
                    <FaAngleDown
                      className="text-blue-500 ml-2"
                      style={{ paddingTop: 3, fontWeight: 600 }}
                    />
                  </Link>

                  {/* Dropdown Menu */}
                  <ul
                    className={`dropdown-menu transition-all duration-300 ease-in-out transform 
        ${
          dropdownOpen
            ? "opacity-100 scale-100 visible"
            : "opacity-0 scale-95 invisible"
        }`}
                  >
                    {/* Speech bubble effect */}
                    <div className="absolute -top-2 left-6 w-4 h-4 bg-white rotate-45 shadow-md"></div>

                    <li>
                      <a
                        href="https://godriveauto.ca/understanding-car-loans"
                        className="dropdown-item"
                      >
                        <div
                          style={{
                            height: "45px",
                            display: "flex",
                            justifyContent: "start",
                            alignItems: "start",
                            marginRight: 1,
                          }}
                        >
                          <FaDollarSign className="text-blue-500" />
                        </div>{" "}
                        <div>
                          <span>Understanding Car Loans</span>
                          <p className="text-sm text-gray-500">
                            Everything you need to know about car loans.
                          </p>
                        </div>{" "}
                      </a>
                    </li>
                    <li>
                      <a href="https://godriveauto.ca/calculator" className="dropdown-item">
                        <div
                          style={{
                            height: "45px",
                            display: "flex",
                            justifyContent: "start",
                            alignItems: "start",
                            marginRight: 1,
                          }}
                        >
                          <FaCalculator className="text-blue-500" />
                        </div>
                        <div>
                          <span>Loan Calculator</span>
                          <p className="text-sm text-gray-500">
                            Easily estimate your monthly car loan payments.
                          </p>
                        </div>{" "}
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </nav>
          </div>
        </div>

        <div className="mobilehead">
          <div>
            {" "}
            <img src={Loogo} className="logoo" />
          </div>

          <div></div>
          <div>
            {" "}
            <div
              className="circlebg newmwnu"
              onClick={() => setOpenClose((m) => !m)}
            >
              <MenuIcon />
            </div>
          </div>
        </div>
        <AnimatePresence>
          {openClose && (
            <motion.div
              className="sidebar-backdrop"
              onClick={() => setOpenClose(false)}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              initial={{ opacity: 0 }}
            >
              <motion.div
                className="bar"
                onClick={(e: any) => e.stopPropagation()}
                animate={{ right: 0, transitionDelay: "-200ms" }}
                exit={{ right: -300 }}
                initial={{ right: -300 }}
              >
                <div className="header-side-bar">
                  <div
                    className="close-icon"
                    onClick={() => setOpenClose(false)}
                  >
                    <Close />
                  </div>

                  <div style={{ flex: 1 }}>
                    <nav>
                    <a
                        href="https://godriveauto.ca"
                        className="list flex-item"
                        onClick={() => {
                          const section = document.querySelector("#home");
                          section?.scrollIntoView({ behavior: "smooth" });
                          setOpenClose(false);
                        }}
                      >
                        <span>Home</span>
                      </a>
                      <NavLink
                        to="./#home"
                        className="list flex-item"
                        onClick={() => {
                          const section = document.querySelector("#home");
                          section?.scrollIntoView({ behavior: "smooth" });
                          setOpenClose(false);
                        }}
                      >
                        <span>Get Pre-Approved</span>
                      </NavLink>

                      <NavLink
                        to="./#why"
                        className="list flex-item"
                        onClick={() => {
                          const section = document.querySelector("#why");
                          section?.scrollIntoView({ behavior: "smooth" });
                          setOpenClose(false);
                        }}
                      >
                        <span>Sell Your Car</span>
                      </NavLink>

                      <NavLink
                        to="./"
                        className="list flex-item"
                        onClick={() => {
                          const section = document.querySelector("#plans");
                          section?.scrollIntoView({ behavior: "smooth" });
                          setOpenClose(false);
                        }}
                      >
                        <span>Inventory</span>
                      </NavLink>

                      <NavLink
                        to="./testimonials"
                        className="list flex-item"
                        onClick={() => {
                          setOpenClose(false);
                        }}
                      >
                        <span>Customer Reviews</span>
                      </NavLink>

                      <NavLink
                        to="./"
                        className="list flex-item"
                        onClick={() => setShowDropdown1(!showDropdown1)}
                      >
                        <span>
                          Resources{" "}
                          <FaAngleDown
                            className="text-blue-500 ml-2"
                            style={{
                              paddingTop: 5,
                              fontWeight: 600,
                              fontSize: 18,
                              marginLeft: 10,
                            }}
                          />
                        </span>
                      </NavLink>

                      {showDropdown1 && (
                        <>
                          <NavLink
                            to="./understanding-car-loans"
                            style={{ marginLeft: 20 }}
                            className="list flex-item"
                            onClick={() => {
                              setOpenClose(false);
                            }}
                          >
                            <span>Understanding Car Loans</span>
                          </NavLink>
                          <NavLink
                            to="./calculator"
                            style={{ marginLeft: 20 }}
                            className="list flex-item"
                            onClick={() => {
                              setOpenClose(false);
                            }}
                          >
                            <span>Loan Calculator</span>
                          </NavLink>
                        </>
                      )}
                    </nav>
                    <div className="allChains"></div>
                  </div>
                </div>
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default Navigation;
